<template>
  <v-app class="bg">
    <v-card flat class="rounded-0 pb-6" color="transparent">
      <toolbar v-bind:isMobile="isMobile" />
      <v-card
        flat
        class="mx-auto col-11 col-sm-9 col-md-9 col-lg-7 col-xl-6 rounded-sm px-0 pa-0 pb-0"
        color="transparent"
        :style="`margin-top: ${isMobile ? '-250px' : '-150px'};`"
      >
        <router-view v-bind:isMobile="isMobile" @msj="msj"></router-view>
      </v-card>
    </v-card>
    <foot />
  </v-app>
</template>
<style lang="sass" scoped>
.bg
    background: rgba(226, 233, 255, 1),
</style>
<script>
import toolbar from '@/components/Toolbar.vue'
import foot from '@/components/Footer.vue'
import IMask from 'imask'

export default {
  components: {
    toolbar,
    foot,
  },
  data: () => ({
    isMobile: null,
  }),
  created() {
    this.mobile(this.$vuetify.breakpoint.name)
    this.$watch('$vuetify.breakpoint.name', (e) => {
      this.mobile(e)
    })
  },
  methods: {
    msj(text, color) {
      this.$emit('msj', text, color)
    },
    mobile(data) {
      switch (data) {
        case 'xs':
        case 'sm':
          this.isMobile = true
          break
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false
          break
      }
    },
  },
}
</script>
